import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import Banner from "./banner"
import { AuthenticateContent, AuthenticateModalTitle } from "./components"
import LoginForm from "./login-form"

const Login = ({ setModalContent }) => {
  const content = (
    <AuthenticateContent>
      <Banner />
      <div className="max-w-375 tablet:max-w-none tablet:px-16 desktop:px-24 m-auto w-full px-24">
        <AuthenticateModalTitle>Sign in to your account</AuthenticateModalTitle>
        <LoginForm setModalContent={setModalContent} />
      </div>
    </AuthenticateContent>
  )

  if (setModalContent) {
    return content
  } else {
    return (
      <div className="contained mb-8">
        <Helmet>
          <title>Signin</title>
        </Helmet>
        <div className="desktop:max-w-855 max-w-640 mx-auto my-24">
          {content}
        </div>
      </div>
    )
  }
}

Login.propTypes = {
  setModalContent: PropTypes.func,
}

export default Login
